import React, { useState, useEffect } from 'react';
import './WhatsAppCard.css';

const WhatsAppCard = () => {
  const [showLogo, setShowLogo] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [whatsappMessage, setWhatsappMessage] = useState("Hello! I need assistance.");
  const whatsappURL = `https://wa.me/8479089674?text=${encodeURIComponent(whatsappMessage)}`;

  useEffect(() => {
    const logoTimeout = setTimeout(() => {
      setShowLogo(true);
      console.log("Logo shown");

      const cardTimeout = setTimeout(() => {
        setShowCard(true);
        console.log("Card shown");
      }, 10000); 

      return () => clearTimeout(cardTimeout);
    }, 20000); 

    return () => clearTimeout(logoTimeout);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCloseCard = () => {
    setShowCard(false);
  };

  const toggleCard = () => {
    setShowCard((prev) => !prev); 
  };

  return (
    <>
      {showBackToTop && (
        <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top-package">
          <i className="bi bi-arrow-up"></i>
        </a>
      )}

      {showLogo && (
        <div className="btn btn-lg btn-primary btn-lg-square-wh whatsapp-new" onClick={toggleCard}>
          <a href="#" className='whastsapp-talk'>
            <i className="fab fa-whatsapp"></i>
            <span>Talk To Us</span>
          </a>
        </div>
      )}

      {showCard && (
        <div className="whatsapp-card show">
          <div className="whatsapp-header">
            <div className="d-flex flex-row gap-1">
            <img src="/assets/images/newlogo1.png" width="50px" height="50px" alt="Logo" />
              <img src="/assets/images/newlogotext1.png" width="170px" height="50px" alt="Logo" />
            </div>
            <button 
              title="Close (Esc)" 
              type="button" 
              className="mfp-close-wp x-button" 
              onClick={handleCloseCard} 
            >
              ×
            </button>
          </div>

          <div className="whatsapp-middle">
            <div className="message received">Hello! How can I help you?</div>
          </div>

          <div className="whatsapp-footer">
          <a 
        className="send-button" 
        href={whatsappURL} 
        target="_blank" 
        rel="noopener noreferrer"
      >
        Start Chat
      </a>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppCard;
